import { useMemo } from 'react';

import { useGetFirmsQuery } from '@/services/api/firmsService';
import { FirmFilters } from '@/services/types/firms-types';

/**
 * Hook for fetching and managing the list of firms
 */
export function useFirmsList(filters: Partial<FirmFilters> = {}) {
  const queryParams = useMemo(
    () => ({
      ...filters,
    }),
    [filters],
  );

  const { data, isLoading, error, refetch } = useGetFirmsQuery(queryParams);

  const firms = data || [];

  return {
    firms,
    isLoading,
    error,
    refetch,
  };
}
